import { css } from "@emotion/react"
import styled from "@emotion/styled"
import { Link } from "gatsby"
import React from "react"
import { BlackButton } from "./ReusableComponents"

const Section = styled.section`
  scroll-behavior: smooth;
  @media (min-width: 768px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`

const Box = styled.div`
  padding: 64px 16px;

  @media (min-width: 768px) {
    order: -1;
    min-width: max-content;
  }

  @media (min-width: 1280px) {
    padding: 0 0 0 32px;
  }

  @media (min-width: 1440px) {
    padding: 0 0 0 64px;
  }
`

const Heading = styled.h2`
  position: relative;
  margin: 0 0 16px 0;

  ::after {
    content: "";
    position: absolute;
    bottom: -16px;
    left: 0;
    width: 300px;
    height: 1px;
    background: ${({ theme }) => theme.black};
  }

  @media (min-width: 1024px) {
    ::after {
      width: 330px;
    }
  }
`

export default function Contact() {
  return (
    <Section id="directions">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3524.105371857421!2d-82.7545638!3d27.960059!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88c2f037b3d3c605%3A0x5da172edf40131b4!2sChamberlain%20Dental!5e0!3m2!1sen!2s!4v1633874584004!5m2!1sen!2s"
        title="chamberlain location"
        allowFullScreen=""
        loading="lazy"
        css={css`
          border: 0;
          width: 100%;
          height: 468px;

          @media (min-width: 1024px) {
            height: 900px;
            width: 62%;
          }
        `}
      ></iframe>
      <Box>
        <Heading>Contact Us</Heading>
        <div
          css={css`
            display: flex;
            padding-top: 16px;
          `}
        >
          <div>
            <p>Call us:</p>
            <p>Email us:</p>
            <p>Find us:</p>
          </div>

          <div
            css={css`
              margin-left: 8px;
            `}
          >
            <p>
              <a
                css={css`
                  color: #037fad;
                `}
                href="tel:+17274416060"
              >
                727-441-6060
              </a>
            </p>
            <p>
              <a
                href="mailto:office@chamberlaindental.com"
                css={css`
                  color: #037fad;
                `}
              >
                office@chamberlaindental.com
              </a>
            </p>
            <p
              css={css`
                margin-bottom: 0;
              `}
            >
              <a
                css={css`
                  color: #037fad;
                `}
                href="https://goo.gl/maps/MvKxTknfVdy29vnG6"
              >
                555 S Hercules Avenue #403
                <br />
                Clearwater, FL 33764
              </a>
            </p>
          </div>
        </div>

        <BlackButton
          as={Link}
          to="/contact-us"
          css={css`
            margin-top: 32px;

            @media (max-width: 767px) {
              display: none;
            }
          `}
        >
          CONTACT US
        </BlackButton>
      </Box>
    </Section>
  )
}
